var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9987 20.1654C5.93595 20.1654 1.83203 16.0614 1.83203 10.9987C1.83203 5.93595 5.93595 1.83203 10.9987 1.83203C16.0614 1.83203 20.1654 5.93595 20.1654 10.9987C20.1654 16.0614 16.0614 20.1654 10.9987 20.1654ZM10.9987 18.332C12.9436 18.332 14.8089 17.5594 16.1841 16.1841C17.5594 14.8089 18.332 12.9436 18.332 10.9987C18.332 9.05378 17.5594 7.18851 16.1841 5.81325C14.8089 4.43798 12.9436 3.66536 10.9987 3.66536C9.05378 3.66536 7.18851 4.43798 5.81325 5.81325C4.43798 7.18851 3.66536 9.05378 3.66536 10.9987C3.66536 12.9436 4.43798 14.8089 5.81325 16.1841C7.18851 17.5594 9.05378 18.332 10.9987 18.332ZM10.082 14.6654H11.9154V16.4987H10.082V14.6654ZM10.082 12.8394C10.082 12.8394 11.9154 12.832 11.9154 12.8394C11.9154 11.9209 14.6654 10.9987 14.6654 9.16536C14.6654 7.13953 13.0401 5.4987 11.0069 5.4987C10.5247 5.49761 10.0471 5.59165 9.60124 5.77543C9.15543 5.95922 8.75024 6.22913 8.40889 6.56972C8.06753 6.91031 7.79671 7.31489 7.61193 7.76028C7.42714 8.20568 7.33203 8.68316 7.33203 9.16536H9.16536C9.16536 8.15703 9.99036 7.33203 10.9987 7.33203C12.007 7.33203 12.832 8.15703 12.832 9.16536C12.832 9.99036 10.082 11.3351 10.082 12.8394Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.b389eef1d8dfa8112a8fcd0a26aa831d.svg";
export { ForwardRef as ReactComponent };